/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Sent_TitleInputs */

const en_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got it, thank you.`)
};

const zh_hans1_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收到，谢谢。`)
};

const pt_br2_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recebido, obrigado.`)
};

const es_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibido, gracias.`)
};

const fr_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C’est noté, merci.`)
};

const de_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angekommen, danke.`)
};

const ru_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принято, спасибо.`)
};

const it_feedback_sent_title = /** @type {(inputs: Feedback_Sent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevuto, grazie.`)
};

/**
* | output |
* | --- |
* | "Got it, thank you." |
*
* @param {Feedback_Sent_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_sent_title = /** @type {((inputs?: Feedback_Sent_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Sent_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_sent_title(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_sent_title(inputs)
	if (locale === "es") return es_feedback_sent_title(inputs)
	if (locale === "fr") return fr_feedback_sent_title(inputs)
	if (locale === "de") return de_feedback_sent_title(inputs)
	if (locale === "ru") return ru_feedback_sent_title(inputs)
	if (locale === "it") return it_feedback_sent_title(inputs)
	return en_feedback_sent_title(inputs)
});